import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { LoaderMain } from "./Styles";

const Loader = ({ center = false, MT = "" }) => {
  return (
    <>
      <LoaderMain>
        <CircularProgress />
      </LoaderMain>
    </>
  );
};

export default Loader;
